import React, { useState, useContext, useReducer, useRef, useEffect } from 'react';
import {
    Toolbar,
    Paper,
    Grid,
    Typography,
    Button,
    Checkbox,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    AppBar,
    Tabs,
    Tab,
    Box,
    IconButton,
    Switch,
    FormControlLabel,
    CircularProgress,
    Chip,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import {ListPageHeading} from '../../components/ListPageLayout';

import api from '../../services/api';
import { PermissionsContext } from '../../providers/Permissions';
import Select from '../../components/Select';
import Input from '../../components/Input';

import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

import AccessKeywords from './components/AccessKeywords';

import PropTypes from 'prop-types';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const classes = useStyles();

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            className={classes.tabPanel}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const getWebhookType = (webhook) => {
    switch (webhook) {
        case 'user_access':
            return 'Acesso Facial';
        case 'face_detection':
            return 'Detecção Facial';
        case 'face_recognition':
            return 'Reconhecimento Facial';
        default:
            return '';
    }
};

const webhookInitialValues = {
    name: "",
    active: false,
    method: "get",
    url: "",
    body: {
        selection: "no_body",
        value: null,
    },
    auth: {
        selection: "no_auth",
        username: null,
        password: null
    },
    query: [],
    header: [],
};
const webHookMethodColors = {
    get: '#c2f0c4',
    post: '#fffbc0',
    put: '#e8ecf7',
    patch: '#d7cafd',
    delete: '#fcc5c5',
};
const webHookMethodFontColor = {
    get: '#2e7d32',
    post: '#ffae00',
    put: '#0131b8',
    patch: '#4a148c',
    delete: '#b71c1c',
}

const reduceWebook = (state, action) => {
    switch (action.type) {
        case "change":
            if (action.index >= 0 && action.innerKey) {
                const changedIndex = { ...state };
                changedIndex[action.name][action.index][action.innerKey] = action.value;
                return changedIndex;
            }

            if (action.innerKey)
                return {
                    ...state,
                    [action.name]: {
                        ...state[action.name],
                        [action.innerKey]: action.value,
                    }
                };

            return {
                ...state,
                [action.name]: action.value,
            };
        case "append_to":
            const appendingTo = { ...state };
            appendingTo[action.name].push({
                active: true,
                name: "",
                value: "",
            });
            return appendingTo;
        case "remove_from":
            const removingFrom = { ...state };
            if (!removingFrom[action.name][action.index])
                return state;

            removingFrom[action.name].splice(action.index, 1);
            return removingFrom;
        case "reset":
            return webhookInitialValues;
        default:
            return state;
    }
};

const QueryHeaderItem = ({
    index,
    origin,
    value,
    onChange,
    onRemove,
}) => {
    const classes = useStyles();
    const [remove, setRemove] = useState(false);
    const timeoutRef = useRef(null);

    const removeItem = () => {
        if (!remove) {
            setRemove(true);
            timeoutRef.current = setTimeout(() => {
                setRemove(false);
            }, 3000)
        } else {
            setRemove(false);
            clearTimeout(timeoutRef.current);
            onRemove({
                origin: origin,
                index: index,
            });
        }
    }

    function changeItemName(e) {
        onChange({
            index: index,
            origin: origin,
            prop: "name",
            value: e.target.value,
        });
    }

    function changeItemValue(e) {
        onChange({
            index: index,
            origin: origin,
            prop: "value",
            value: e.target.value,
        });
    }

    function toggleItem(e) {
        onChange({
            index: index,
            origin: origin,
            prop: "active",
            value: e.target.checked,
        });
    }

    useEffect(() => {
        return () => {
            clearTimeout(timeoutRef.current);
        }
    }, []);

    return (
        <Grid item xs={12}>
            <Paper variant="outlined" className={classes.parameterRow}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid item className={classes.parameterToggle}>
                        <Checkbox
                            color='primary'
                            checked={value.active}
                            onChange={toggleItem}
                        />
                    </Grid>
                    <Grid item xs={12} sm>
                        <Input
                            textFieldProps={{
                                placeholder: 'Nome',
                                value: value.name,
                                onChange: changeItemName,
                                fullWidth: true,
                                required: true,
                                disabled: !value.active,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm>
                        <Input
                            textFieldProps={{
                                placeholder: 'Valor',
                                value: value.value,
                                onChange: changeItemValue,
                                fullWidth: true,
                                required: true,
                                disabled: !value.active,
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <IconButton
                            className={remove ? classes.deleteButtonConfirm : classes.deleteButton}
                            onClick={removeItem}
                            aria-label={remove ? 'Confirmar exclusão' : 'Excluir item'}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

const Webhook = ({
    data,
    setMessage,
}) => {
    const classes = useStyles();

    const {
        PermissionWrapper,
    } = useContext(PermissionsContext);

    const [webhook, dispatchWebhook] = useReducer(reduceWebook, data);

    const [savingHook, setSavingHook] = useState(false);

    const [currentTab, setCurrentTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const [openKeywords, setOpenKeywords] = useState(false);

    function changeWebhookActive(e) {
        dispatchWebhook({
            type: "change",
            name: "active",
            value: e.target.checked,
        });
    }

    function changeMethod(e) {
        dispatchWebhook({
            type: "change",
            name: "method",
            value: e.target.value,
        });
    }

    function changeUrl(e) {
        dispatchWebhook({
            type: "change",
            name: "url",
            value: e.target.value,
        });
    }

    function changeBodySelection(e) {
        dispatchWebhook({
            type: "change",
            name: "body",
            innerKey: "selection",
            value: e.target.value,
        });
    }

    function changeAuthSelection(e) {
        dispatchWebhook({
            type: "change",
            name: "auth",
            innerKey: "selection",
            value: e.target.value,
        });
    }

    function changeAuthUsername(e) {
        dispatchWebhook({
            type: "change",
            name: "auth",
            innerKey: "username",
            value: e.target.value,
        });
    }

    function changeAuthPassword(e) {
        dispatchWebhook({
            type: "change",
            name: "auth",
            innerKey: "password",
            value: e.target.value,
        });
    }

    function appendToQuery() {
        dispatchWebhook({
            type: "append_to",
            name: "query",
        });
    }

    function appendToHeader() {
        dispatchWebhook({
            type: "append_to",
            name: "header",
        });
    }

    function removeFromQueryOrHeader({ index, origin }) {
        dispatchWebhook({
            type: "remove_from",
            name: origin,
            index: index,
        });
    }

    function changeQueryHeader({ index, origin, prop, value }) {
        dispatchWebhook({
            type: "change",
            name: origin,
            index: index,
            innerKey: prop,
            value: value,
        });
    }

    function changeOpenKeywords(e) {
        setOpenKeywords(e.target.checked);
    }

    async function saveWebhook() {
        setSavingHook(true);
        try {
            console.log(webhook);

            const response = await api.post('/webhook/modify', webhook);

            console.log(response.data)

            setMessage({
                open: true,
                variant: 'success',
                text: 'Webhook atualizado com sucesso',
            });
        } catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error ?? "Não foi possível atualizar esse webhook",
            });
        }
        setSavingHook(false);
    }

    return (
        <Accordion
            className={classes.webhookCard}
            elevation={0}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`webhook-${webhook.name}-content`}
                id={`webhook-${webhook.name}-header`}
                className={classes.webhookSummary}
            >
                <div className={classes.summaryContent}>
                    <span className={`${classes.statusDot} ${webhook.active ? classes.statusDotActive : ''}`} />
                    <div className={classes.summaryText}>
                        <Typography className={classes.heading}>
                            {getWebhookType(webhook.name)}
                        </Typography>
                        <Typography className={classes.webhookUrl}>
                            {webhook.url || 'URL não configurada'}
                        </Typography>
                    </div>
                    <Chip
                        size="small"
                        label={webhook.method.toUpperCase()}
                        className={classes.methodChip}
                        style={{ backgroundColor: webHookMethodColors[webhook.method], color: webHookMethodFontColor[webhook.method] }}
                    />
                    <Chip
                        size="small"
                        label={webhook.active ? 'Ativado' : 'Desativado'}
                        className={webhook.active ? classes.activeChip : classes.inactiveChip}
                    />
                </div>
            </AccordionSummary>
            <AccordionDetails className={classes.webhookDetails}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={2}>
                                <Select
                                    label="Método"
                                    options={[
                                        { label: 'GET', value: 'get' },
                                        { label: 'POST', value: 'post' },
                                        { label: 'PUT', value: 'put' },
                                        { label: 'PATCH', value: 'patch' },
                                        { label: 'DELETE', value: 'delete' },
                                    ]}
                                    textFieldProps={{
                                        value: webhook.method,
                                        onChange: changeMethod,
                                        fullWidth: true,
                                        required: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={8} md={10}>
                                <Input
                                    label="Endpoint"
                                    textFieldProps={{
                                        placeholder: 'URL',
                                        value: webhook.url,
                                        onChange: changeUrl,
                                        fullWidth: true,
                                        required: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <AppBar position="static" color="default" elevation={0} className={classes.tabsBar}>
                            <Tabs
                                value={currentTab}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                textColor="primary"
                                aria-label="settings"
                            >
                                <Tab label="Body" {...a11yProps(0)} />
                                <Tab label="Auth" {...a11yProps(1)} />
                                <Tab label="Query" {...a11yProps(2)} />
                                <Tab label="Header" {...a11yProps(3)} />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={currentTab} index={0}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Select
                                        label="Formato do body"
                                        options={[
                                            { label: 'No Body', value: 'no_body' },
                                            { label: 'JSON', value: 'json' },
                                        ]}
                                        textFieldProps={{
                                            value: webhook.body.selection,
                                            onChange: changeBodySelection,
                                            fullWidth: true,
                                            required: true,
                                        }}
                                    />
                                </Grid>
                                {
                                    webhook.body.selection !== 'no_body' && (
                                        <Grid item xs={12}>
                                            <Editor
                                                value={webhook.body.value}
                                                onChange={(event) => {
                                                    dispatchWebhook({
                                                        type: "change",
                                                        name: "body",
                                                        innerKey: "value",
                                                        value: event
                                                    });
                                                }}
                                            />
                                        </Grid>
                                    )
                                }
                            </Grid>
                        </TabPanel>
                        <TabPanel value={currentTab} index={1}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Select
                                        label="Autenticação"
                                        options={[
                                            { label: "No Auth", value: "no_auth" },
                                            { label: 'Basic Auth', value: 'basic' },
                                            { label: 'Digest Auth', value: 'digest' },
                                        ]}
                                        textFieldProps={{
                                            value: webhook.auth.selection,
                                            onChange: changeAuthSelection,
                                            fullWidth: true,
                                            required: true,
                                        }}
                                    />
                                </Grid>
                                {
                                    webhook.auth.selection !== 'no_auth' && (
                                        <>
                                            <Grid item xs={12}>
                                                <Input
                                                    label="Username"
                                                    textFieldProps={{
                                                        placeholder: 'Username',
                                                        value: webhook.auth.username,
                                                        onChange: changeAuthUsername,
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Input
                                                    label="Password"
                                                    textFieldProps={{
                                                        value: webhook.auth.password,
                                                        onChange: changeAuthPassword,
                                                        placeholder: 'password',
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                />
                                            </Grid>
                                        </>
                                    )
                                }
                            </Grid>
                        </TabPanel>
                        <TabPanel value={currentTab} index={2}>
                            <Grid container spacing={3}>
                                {
                                    webhook.query.map((queryItem, queryIndex) => (
                                        <QueryHeaderItem
                                            key={queryIndex}
                                            index={queryIndex}
                                            origin="query"
                                            value={queryItem}
                                            onChange={changeQueryHeader}
                                            onRemove={removeFromQueryOrHeader}
                                        />
                                    ))
                                }
                                <Grid
                                    item
                                    xs={12}
                                    className={classes.addButtonContainer}
                                >
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        onClick={appendToQuery}
                                        startIcon={<AddIcon />}
                                        className={classes.addButton}
                                    >
                                        Adicionar parâmetro
                                    </Button>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={currentTab} index={3}>
                            <Grid container spacing={3}>
                                {
                                    webhook.header.map((headerItem, headerIndex) => (
                                        <QueryHeaderItem
                                            key={headerIndex}
                                            index={headerIndex}
                                            origin="header"
                                            value={headerItem}
                                            onChange={changeQueryHeader}
                                            onRemove={removeFromQueryOrHeader}
                                        />
                                    ))
                                }
                                <Grid
                                    item
                                    xs={12}
                                    className={classes.addButtonContainer}
                                >
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        onClick={appendToHeader}
                                        startIcon={<AddIcon />}
                                        className={classes.addButton}
                                    >
                                        Adicionar cabeçalho
                                    </Button>
                                </Grid>
                            </Grid>
                        </TabPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper variant="outlined" className={classes.settingsPanel}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        className={classes.switchLabel}
                                        control={(
                                            <Switch
                                                color="primary"
                                                checked={Boolean(webhook.active)}
                                                onChange={changeWebhookActive}
                                            />
                                        )}
                                        label={webhook.active ? 'Webhook ativado' : 'Webhook desativado'}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        className={classes.switchLabel}
                                        control={(
                                            <Switch
                                                color="primary"
                                                checked={openKeywords}
                                                onChange={changeOpenKeywords}
                                            />
                                        )}
                                        label="Mostrar palavras-chave disponíveis"
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    {
                        openKeywords && (
                            <AccessKeywords />
                        )
                    }
                    <PermissionWrapper route="/webhooks/modificar">
                        <Grid item xs={12} className={classes.saveContainer}>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={saveWebhook}
                                disabled={savingHook}
                                startIcon={!savingHook && <SaveIcon />}
                                className={classes.saveButton}
                            >
                                {
                                    savingHook
                                        ? "Salvando..."
                                        : "Salvar"
                                }
                            </Button>
                        </Grid>
                    </PermissionWrapper>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default function WebhookList() {
    const classes = useStyles();

    const [webhooks, setWebhooks] = useState([]);
    const [loading, setLoading] = useState(true);

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    useEffect(() => {
        (async () => {
            try {
                const result = await api.get('/webhook/list');

                const { webhooks: fetchedWebhooks } = result.data;

                console.log({ fetchedWebhooks });

                setWebhooks(fetchedWebhooks);
            } catch (err) {
                console.log(err);
                setMessage({
                    open: true,
                    variant: 'error',
                    text: err.error ?? "Não foi possível listar os webhooks",
                });
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} >
                    <Grid item xs={12}>
                         <ListPageHeading icon="webhook" title="Webhooks" />
                        {/*<div className={classes.pageHeader}>
                            {<div className={classes.headerIcon}>
                                <SettingsEthernetIcon />
                            </div>}
                            <div>
                                <Typography variant="h5" className={classes.title}>
                                    Webhooks
                                </Typography>
                                {<Typography className={classes.subtitle}>
                                    Configure como os eventos da plataforma serão enviados para sistemas externos.
                                </Typography>}
                            </div>
                        </div>*/}
                    </Grid>
                    <Grid item xs={12}>
                        <Paper elevation={0} className={classes.paper}>
                            {loading ? (
                                <div className={classes.feedbackState}>
                                    <CircularProgress size={30} />
                                    <Typography>Carregando webhooks...</Typography>
                                </div>
                            ) : webhooks.length ? (
                                <Grid container spacing={2}>
                                    {webhooks.map((webhook) => (
                                        <Grid item xs={12} key={webhook.id}>
                                            <Webhook
                                                data={webhook}
                                                setMessage={setMessage}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                <div className={classes.feedbackState}>
                                    <SettingsEthernetIcon className={classes.emptyIcon} />
                                    <Typography variant="h6">Nenhum webhook encontrado</Typography>
                                    <Typography color="textSecondary">
                                        Não há integrações disponíveis para configurar no momento.
                                    </Typography>
                                </div>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div >
    );


}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
        
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    headerIcon: {
        width: 52,
        height: 52,
        flexShrink: 0,
        borderRadius: 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        boxShadow: `0 8px 20px ${theme.palette.primary.main}35`,
        '& svg': {
            fontSize: 28,
        },
    },
    title: {
        color: 'rgba(6, 19, 31, 1)',
        fontSize: 30,
        lineHeight: 1.2,
        fontWeight: 700,
        letterSpacing: '-0.02em',
    },
    subtitle: {
        color: grey[600],
        marginTop: theme.spacing(.5),
        [theme.breakpoints.down('xs')]: {
            fontSize: 13,
        },
    },
    paper: {
        borderRadius: 16,
        width: '100%',
        padding: theme.spacing(2),
        border: `1px solid ${grey[200]}`,
        backgroundColor: 'rgba(255, 255, 255, .88)',
        boxShadow: '0 8px 30px rgba(30, 42, 60, .06)',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    webhookCard: {
        border: `1px solid ${grey[200]}`,
        borderRadius: '12px !important',
        overflow: 'hidden',
        backgroundColor: '#fff',
        transition: 'box-shadow .2s ease, border-color .2s ease',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
            borderColor: theme.palette.primary.light,
            boxShadow: '0 10px 26px rgba(30, 42, 60, .09)',
        },
    },
    webhookSummary: {
        minHeight: 76,
        padding: theme.spacing(0, 2.5),
        '&.Mui-expanded': {
            minHeight: 76,
        },
        '& .MuiAccordionSummary-content': {
            minWidth: 0,
            margin: theme.spacing(1.5, 0),
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: theme.spacing(1.5, 0),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 1.5),
        },
    },
    summaryContent: {
        width: '100%',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    summaryText: {
        flex: 1,
        minWidth: 0,
    },
    statusDot: {
        width: 10,
        height: 10,
        flexShrink: 0,
        borderRadius: '50%',
        backgroundColor: grey[400],
        boxShadow: `0 0 0 4px ${grey[100]}`,
    },
    statusDotActive: {
        backgroundColor: '#2eaf6f',
        boxShadow: '0 0 0 4px rgba(46, 175, 111, .13)',
    },
    webhookUrl: {
        maxWidth: 620,
        marginTop: 2,
        overflow: 'hidden',
        color: grey[500],
        fontSize: 13,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    methodChip: {
        height: 26,
        color: '#fff',
        backgroundColor: '#388e3c',
        fontWeight: 700,
        fontSize: 11,
    },
    activeChip: {
        height: 26,
        color: '#16794b',
        backgroundColor: '#e8f7ef',
        fontWeight: 600,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    inactiveChip: {
        height: 26,
        color: grey[600],
        backgroundColor: grey[100],
        fontWeight: 600,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    webhookDetails: {
        display: 'block',
        padding: theme.spacing(3),
        borderTop: `1px solid ${grey[200]}`,
        backgroundColor: '#fbfcfe',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    tabsBar: {
        overflow: 'hidden',
        color: grey[700],
        border: `1px solid ${grey[200]}`,
        borderRadius: '10px 10px 0 0',
        backgroundColor: '#f4f6f9',
        '& .MuiTab-root': {
            minHeight: 52,
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    tabPanel: {
        minHeight: 132,
        border: `1px solid ${grey[200]}`,
        borderTop: 0,
        borderRadius: '0 0 10px 10px',
        backgroundColor: '#fff',
        '& > .MuiBox-root': {
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2),
            },
        },
    },
    parameterRow: {
        padding: theme.spacing(1.5),
        borderColor: grey[200],
        borderRadius: 10,
        backgroundColor: '#fafbfc',
    },
    parameterToggle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    deleteButton: {
        color: grey[500],
        transition: 'all .2s ease',
        '&:hover': {
            color: theme.palette.error.main,
            backgroundColor: '#fff0f0',
        },
    },
    deleteButtonConfirm: {
        color: '#fff',
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
    addButtonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    addButton: {
        borderStyle: 'dashed',
        borderRadius: 9,
        textTransform: 'none',
        fontWeight: 600,
    },
    settingsPanel: {
        padding: theme.spacing(1.5, 2),
        borderColor: grey[200],
        borderRadius: 10,
        backgroundColor: '#fff',
    },
    switchLabel: {
        marginLeft: 0,
        '& .MuiFormControlLabel-label': {
            color: grey[700],
            fontSize: 14,
            fontWeight: 600,
        },
    },
    saveContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    saveButton: {
        minWidth: 132,
        minHeight: 40,
        borderRadius: 9,
        textTransform: 'none',
        fontWeight: 700,
        boxShadow: '0 6px 14px rgba(0, 0, 0, .12)',
    },
    feedbackState: {
        minHeight: 240,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(4),
        color: grey[600],
        textAlign: 'center',
    },
    emptyIcon: {
        marginBottom: theme.spacing(1),
        color: grey[400],
        fontSize: 48,
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    tableHead: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: grey[500],
    },
    tableBody: {
        color: grey[800],
        textAlign: 'center',
    },
    actionButton: {
        margin: theme.spacing(0, .5),
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
    heading: {
        color: grey[800],
        fontSize: theme.typography.pxToRem(17),
        fontWeight: 700,
    },
}));
